import { useQuery } from '@zg-rentals/react-query5';
import { getPropertyDetails } from '../../actions/propertyActions';
import { useDispatch, useSelector } from 'react-redux';
import { listingAliasSelector } from '../../selectors';
import { GET_PROPERTY_DETAILS } from '../../constants/requests';
import useQueryParams from '../../hooks/useQueryParams';
import {
  emitZtssContinueEnterYourAddressEvent,
  emitZtssContinueWhoScreeningEvent,
  emitZtssEnterYourAddressEvent,
  emitZtssWhoScreeningEvent,
} from '../../../client/analytics/clickstreamEvents';

export const WIZARD_STEPS = {
  ENTER_YOUR_NAME: 'enter-your-name',
  ENTER_YOUR_ADDRESS: 'enter-your-address',
  INVITE_A_RENTER: 'invite-a-renter',
};

export function useSyncListing() {
  const { propertyId } = useQueryParams();
  const listingAlias = useSelector(listingAliasSelector);
  const dispatch = useDispatch();
  const { isFetching, ...rest } = useQuery({
    queryKey: ['getPropertyDetails', propertyId],
    async queryFn() {
      const response = await dispatch(getPropertyDetails(propertyId));
      if (response.type === GET_PROPERTY_DETAILS.FAILURE) {
        throw response.error;
      }
      return response;
    },
    enabled: listingAlias !== propertyId,
  });
  return { isSynced: !isFetching && listingAlias && propertyId && listingAlias === propertyId, isFetching, ...rest };
}

export function getClickstreamEventsByStepId(stepId) {
  switch (stepId) {
    case WIZARD_STEPS.ENTER_YOUR_NAME:
      return {
        viewEvent: emitZtssWhoScreeningEvent,
        continueEvent: emitZtssContinueWhoScreeningEvent,
        hasListingInfo: false,
      };
    case WIZARD_STEPS.ENTER_YOUR_ADDRESS:
      return {
        viewEvent: emitZtssEnterYourAddressEvent,
        continueEvent: emitZtssContinueEnterYourAddressEvent,
        hasListingInfo: false,
      };
    // the invite renter step events must be handled in InviteARenterStep
    default:
      return null;
  }
}
